import { render } from "./Home.vue.js?vue&type=template&id=1d926fa5!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Home.vue?vue&type=template&id=1d926fa5"
import script from "./Home.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Home.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d926fa5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d926fa5', __exports__)) {
    api.reload('1d926fa5', __exports__)
  }
  
  module.hot.accept("./Home.vue.js?vue&type=template&id=1d926fa5!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Home.vue?vue&type=template&id=1d926fa5", () => {
    api.rerender('1d926fa5', render)
  })

}


export default __exports__